import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=7ae76803"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__